<template>
  <div>
    <b-row>
      <loader v-if="loading" />
      <b-col v-for="(item, index) in plans" :key="index" cols="12" md="6" lg="6" xl="4">
        <WallkitPlanCard 
          :id="item.id"
          :item="item"
          @onEditPlan="(planId) => {$router.push(`/wallkit-pricing/edit/${planId}`)}"
          @onDeletePlan="onDelete"
        />
      </b-col>
      <b-col cols="12" md="6" lg="4">
        <b-button
          variant="outline-primary"
          size="sm"
          style="height: 40px; width: 40px"
          @click="$router.push('wallkit-pricing/create')"
        >
          <i class="fas fa-plus fa-lg" />
        </b-button>
      </b-col>
    </b-row>
    <modal 
      :show-modal="showDeleteModal"
      :title="$t('wallkit_pricing.delete_message')"
      @cancel="cancelDelete"
      @ok="deletePlan"
      @hide="cancelDelete"
    />
  </div>
</template>

<script>
import WallkitPlanCard from "./WallkitPlanCard";
export default {
  name: "WallkitPricing",
  components: {WallkitPlanCard},
  middleware: ['auth', 'root-auth'],
  data () {
    return {
      plans: [],
      showDeleteModal: false,
      loading: false,
      deletePlanId: null
    }
  },
  mounted () {
    this.getPricingPlans()
  },
  methods: {
    async getPricingPlans () {
      this.loading = true
      await this.getData(`pricing/plans`).then(response => {
        this.plans = response.data.items
      })
      .catch(error => {
        console.log('get plans error', error)
      })
      this.loading = false
    },
    onDelete (id) {
      this.showDeleteModal = true
      this.deletePlanId = id
    },
    cancelDelete () {
      this.showDeleteModal = false
      this.deletePlanId = null
    },
    deletePlan () {
      this.loading = true
      this.deleteData(`pricing/plans/${this.deletePlanId}`)
      .then(() => {
        this.deletePlanId = null
        this.showDeleteModal = false
        this.getPricingPlans()
      })
      .catch(error => {
        console.log('delete plan error', error)
      })
      this.loading = false
    }
  }
}
</script>
